import Styled from "styled-components";

export const TitleProduct = Styled.p`
`;

export const Box = Styled.div`
`;

export const SellerName = Styled.h2`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  letter-spacing: 0%;
  color: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
`;

export const BrandName = Styled.p`
  font-size: 12px;
  font-weight: 600;
  line-height: 18px;
  letter-spacing: 0%;
  color: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
  margin: 0;
`;

export const ProductName = Styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px%;
  letter-spacing: 0%;
  color: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
  margin: 0;
  margin-top: 14px;
  font-style: normal;
`;

export const ProductVariant = Styled.p`
  color: #595959;
  font-family: var(--font-family);
  font-size: 12px;
  font-style: normal;
  font-weight: 600;
  line-height: 18px;
  margin: 0;
  margin-top: 14px;
`;

export const SummaryLabel = Styled.p`
  font-size: 14px;
  font-weight: 600;
  line-height: 20px; 
  letter-spacing: 0%;
  color: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
  margin: 0;
  font-style: normal;
`;

export const SummaryValue = Styled.p`
  font-size: 14px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0%;
  color: ${(props) => props.theme.whitelabel?.theme?.text_primary_color};
  margin: 0;
  text-align: right;
  font-style: normal;
`;

export const Line = Styled.div`
  margin-top: 5px;
  margin-bottom: 5px;
  border: solid 1px #F0F0F0;
`;

export const ThumbContainer = Styled.div`
  position: relative;
`;

export const QuantityBadge = Styled.p`
  position: absolute;
  top: 4px;
  right: 4px;
  background: ${(props) => props.theme.whitelabel?.theme?.button_primary_color || "#6B33D9"};
  border-radius: 10px;
  min-width: 20px;
  height: 20px;
  padding: 4px 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  margin: 0;
`;
